// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*:root {*/
/*    --card-dark: #111;*/
/*    --background-dark: #000;*/
/*    --border-dark: rgba(255,255,255,0.1);*/
/*}*/

/* --- TITRES --- */
.content h1 {
    font-size: 2rem;
    margin-bottom: 10px;
    color: var(--text);
}

.content h2 {
    font-size: 1.4rem;
    margin-bottom: 15px;
    color: var(--text);
}

/* --- CARD BLOCK --- */
/* --- BLOC GLOBAL --- */
.card-block {
    background: #ffffff;              /* fond clair */
    border: 1px solid #dcdcdc;        /* bordure visible */
    border-radius: 12px;
    padding: 25px;
    margin-bottom: 30px;              /* espace entre les blocs */
    box-shadow: 0 4px 12px rgba(0,0,0,0.06); /* ombre douce */
}

/* TITRES */
.card-block h2 {
    margin-top: 0;
    margin-bottom: 15px;
    font-size: 1.4rem;
    color: #222;
}

/* --- DARK MODE : blocs plus clairs --- */
.dashboard.dark .card-block {
    background: #1a2228; /* plus clair que #2f3136 */
    border: 1px solid rgba(255,255,255,0.18);
    box-shadow: 0 4px 12px rgba(0,0,0,0.35);
}

/* Titres dans les blocs */
.dashboard.dark .card-block h2 {
    color: #ffffff;
}

/* Textes */
.dashboard.dark .card-block p,
.dashboard.dark .card-block label,
.dashboard.dark .card-block li {
    color: #e8e8e8;
}



/* --- BLOCS / CARDS --- */
.card-block textarea {
    width: 100%;
    min-height: 150px;
    padding: 15px;
    border-radius: 8px;
    border: 1px solid #ccc;
    background: #ffffff;
    color: #333;
    font-size: 1rem;
    line-height: 1.4;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

/* Effet focus premium */
.card-block textarea:focus {
    border-color: #6fb8af;
    box-shadow: 0 0 0 2px rgba(111,184,175,0.25);
}

/* Dark mode */
.dashboard.dark .card-block textarea {
    background: #2b2d31;
    color: #f5f5f5;
    border: 1px solid rgba(255,255,255,0.2);
}


/* --- CHECKLIST --- */
.checklist {
    list-style: none;
    padding: 0;
    margin: 0;
}

.checklist li {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 0;
    border-bottom: 1px solid var(--border);
    color: var(--text);
}

.checklist li:last-child {
    border-bottom: none;
}

.checklist input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: #6fb8af; /* ton vert */
}

/* --- RESSOURCES --- */
.resource-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.resource-list a {
    color: #6fb8af;
    text-decoration: none;
    font-weight: 500;
    transition: 0.2s;
}

.resource-list a:hover {
    opacity: 0.7;
}

/* --- NOTES --- */
.card-block textarea {
    resize: vertical;
    font-size: 1rem;
    line-height: 1.4;
}

/* --- LAYOUT 2 COLS --- */
.layout-two-cols {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 25px;
    margin-top: 25px;
}

/* --- TIMELINE --- */
.timeline {
    position: relative;
    margin-left: 20px;
    padding-left: 20px;
    border-left: 2px solid var(--border);
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.timeline-item {
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: 15px;
}

.timeline-dot {
    position: absolute;
    left: -31px;
    top: 4px;
    width: 14px;
    height: 14px;
    background: #6fb8af;
    border-radius: 50%;
    border: 2px solid var(--card);
    box-shadow: 0 0 0 3px rgba(111,184,175,0.25);
}

.timeline-content h3 {
    margin: 0;
    font-size: 1.1rem;
    color: var(--text);
}

.timeline-content p {
    margin: 3px 0 0;
    opacity: 0.7;
    color: var(--text);
}

/* --- SELECTED TIMELINE --- */

/* --- TIMELINE --- */
.timeline {
    position: relative;
    margin-left: 20px;
    padding-left: 20px;
    border-left: 2px solid #ccc;
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.dashboard.dark .timeline {
    border-left-color: rgba(255,255,255,0.15);
}

.timeline-item {
    position: relative;
    padding-left: 10px;
    cursor: pointer;
    transition: 0.2s;
}

.timeline-item:hover {
    opacity: 0.8;
}

.timeline-dot {
    position: absolute;
    left: -31px;
    top: 4px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 2px solid #fff;
}

/* --- STATUTS --- */
.timeline-item.done .timeline-dot {
    background: #4caf50;
    box-shadow: 0 0 0 3px rgba(76,175,80,0.25);
}

.timeline-item.progress .timeline-dot {
    background: #ff9800;
    box-shadow: 0 0 0 3px rgba(255,152,0,0.25);
}

.timeline-item.todo .timeline-dot {
    background: #9e9e9e;
    box-shadow: 0 0 0 3px rgba(158,158,158,0.25);
}

.timeline-content h3 {
    margin: 0;
    font-size: 1.1rem;
    color: var(--text);
}

.timeline-content .date {
    margin: 3px 0 0;
    opacity: 0.7;
    color: var(--text);
}

.dashboard.dark .timeline-dot {
    border-color: #2f3136;
}

/* --- MODAL --- */
.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.55);
    backdrop-filter: blur(3px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

/* Light mode modal */
.modal-card {
    background: #ffffff;
    border: 1px solid #ddd;
    padding: 25px;
    border-radius: 12px;
    width: 400px;
    max-width: 90%;
    box-shadow: 0 8px 30px rgba(0,0,0,0.3);
    animation: fadeIn 0.2s ease;
}

/* Dark mode modal */
.dashboard.dark .modal-card {
    background: #2f3136;
    border: 1px solid rgba(255,255,255,0.12);
    color: #f5f5f5;
}

.close-btn {
    margin-top: 20px;
    padding: 10px 15px;
    background: #6fb8af;
    border: none;
    border-radius: 8px;
    color: white;
    cursor: pointer;
    width: 100%;
}

.close-btn:hover {
    opacity: 0.8;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}



/* --- DARK MODE --- */
.dashboard.dark .timeline {
    border-left-color: var(--border-dark);
}

.dashboard.dark .timeline-dot {
    border-color: var(--card-dark);
}

/* --- TIMELINE HORIZONTAL --- */

/* --- TIMELINE HORIZONTAL --- */
.timeline-horizontal {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    padding: 40px 10px 20px;
    border-top: 2px solid #ccc;
    overflow-x: auto;
    gap: 40px;
}

/* Ligne en dark mode */
.dashboard.dark .timeline-horizontal {
    border-top-color: rgba(255,255,255,0.15);
}

/* Chaque étape */
.th-item {
    position: relative;
    text-align: center;
    cursor: pointer;
    min-width: 150px;
    transition: 0.2s;
}

.th-item:hover {
    opacity: 0.8;
}

/* Pastille */
.th-dot {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin: 0 auto;
    margin-bottom: 10px;
    border: 3px solid #fff;
}

/* Statuts */
.th-item.done .th-dot {
    background: #4caf50;
    box-shadow: 0 0 0 4px rgba(76,175,80,0.25);
}

.th-item.progress .th-dot {
    background: #ff9800;
    box-shadow: 0 0 0 4px rgba(255,152,0,0.25);
}

.th-item.todo .th-dot {
    background: #9e9e9e;
    box-shadow: 0 0 0 4px rgba(158,158,158,0.25);
}

/* Textes */
.th-title {
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
    color: #333;
}

.th-date {
    font-size: 0.85rem;
    opacity: 0.7;
    margin: 5px 0 0;
    color: #333;
}

/* Dark mode */
.dashboard.dark .th-title,
.dashboard.dark .th-date {
    color: #f5f5f5;
}

.dashboard.dark .th-dot {
    border-color: #2f3136;
}

/* --- PROGRESSION --- */
.progress-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.progress-bar {
    width: 100%;
    height: 14px;
    background: #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
}

.progress-fill {
    height: 100%;
    background: #6fb8af;
    border-radius: 8px;
    transition: width 0.4s ease;
}

.progress-text {
    font-size: 0.95rem;
    font-weight: 600;
    color: #333;
}

/* Dark mode */
.dashboard.dark .progress-bar {
    background: #3a3b3d;
}

.dashboard.dark .progress-text {
    color: #f5f5f5;
}

/* --- TAGS --- */
.tag {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: capitalize;
    margin-top: 8px;
    color: white;
}

/* Couleurs par catégorie */
.tag-administratif {
    background: #3f51b5; /* bleu */
}

.tag-logement {
    background: #009688; /* vert turquoise */
}

.tag-emploi {
    background: #ff9800; /* orange */
}

.tag-banque {
    background: #4caf50; /* vert */
}

.tag-santé {
    background: #e91e63; /* rose */
}

.tag-éducation {
    background: #9c27b0; /* violet */
}

/* Dark mode : couleurs identiques, mais texte plus lisible */
.dashboard.dark .tag {
    color: #fff;
}

/* --- BUDGET GRID --- */
.budget-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 25px;
    margin-top: 20px;
}

@media (max-width: 900px) {
    .budget-grid {
        grid-template-columns: 1fr;
    }
}

.budget-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.budget-item label {
    font-size: 0.95rem;
    font-weight: 600;
    color: #222;
}

.budget-item input {
    padding: 12px 14px;
    border-radius: 10px;
    border: 1px solid #d0d0d0;
    background: #fafafa;
    color: #222;
    font-size: 1rem;
    transition: 0.2s;
}

.budget-item input:focus {
    border-color: #6fb8af;
    background: #fff;
    box-shadow: 0 0 0 2px rgba(111,184,175,0.25);
}

/* --- TOTAL --- */
.budget-total {
    margin-top: 30px;
    padding: 18px;
    background: #f0f0f0;
    border-radius: 10px;
    border: 1px solid #d0d0d0;
}

.budget-total h3 {
    margin: 0;
    font-size: 1.3rem;
    color: #222;
}

.budget-total span {
    color: #6fb8af;
    font-weight: 700;
}

/* --- DARK MODE --- */
.dashboard.dark .budget-item label {
    color: #f5f5f5;
}

.dashboard.dark .budget-item input {
    background: #3f4147;
    border: 1px solid rgba(255,255,255,0.15);
    color: #fff;
}

.dashboard.dark .budget-item input:focus {
    border-color: #6fb8af;
    background: #4a4c53;
    box-shadow: 0 0 0 2px rgba(111,184,175,0.25);
}

.dashboard.dark .budget-total {
    background: #3f4147;
    border: 1px solid rgba(255,255,255,0.15);
}

.dashboard.dark .budget-total h3 {
    color: #fff;
}


/* --- ONGLET --- */
.tabs {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
}

.tabs button {
    padding: 10px 18px;
    border-radius: 8px;
    border: 1px solid #ccc;
    background: #f5f5f5;
    cursor: pointer;
    font-weight: 600;
    transition: 0.2s;
}

.tabs button.active {
    background: #6fb8af;
    color: white;
    border-color: #6fb8af;
}

.tabs button:hover {
    opacity: 0.85;
}

/* Dark mode */
.dashboard.dark .tabs button {
    background: #3a3c42;
    border: 1px solid rgba(255,255,255,0.15);
    color: #fff;
}

.dashboard.dark .tabs button.active {
    background: #6fb8af;
    border-color: #6fb8af;
    color: #fff;
}

/* --- LOGEMENT --- */
.logement-section {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.logement-section input,
.logement-section select,
.logement-section textarea {
    padding: 10px;
    border-radius: 8px;
    border: 1px solid #ccc;
    background: #fff;
    color: #333;
}

/* Dark mode */
.dashboard.dark .logement-section input,
.dashboard.dark .logement-section select,
.dashboard.dark .logement-section textarea {
    background: #2b2d31;
    border: 1px solid rgba(255,255,255,0.2);
    color: #fff;
}

/* --- EMPLOI SECTION --- */
.emploi-section {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.emploi-section input,
.emploi-section textarea {
    padding: 12px;
    border-radius: 10px;
    border: 1px solid #ccc;
    background: #fafafa;
    color: #222;
    font-size: 1rem;
}

.emploi-section textarea {
    min-height: 100px;
}

/* Dark mode */
.dashboard.dark .emploi-section input,
.dashboard.dark .emploi-section textarea {
    background: #3f4147;
    border: 1px solid rgba(255,255,255,0.15);
    color: #fff;
}

/* --- SECTIONS GENERIQUES --- */
.ecoles-section,
.sante-section {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.ecoles-section input,
.ecoles-section select,
.ecoles-section textarea,
.sante-section input,
.sante-section select,
.sante-section textarea {
    padding: 12px;
    border-radius: 10px;
    border: 1px solid #ccc;
    background: #fafafa;
    color: #222;
    font-size: 1rem;
}

.ecoles-section textarea,
.sante-section textarea {
    min-height: 100px;
}

/* --- DARK MODE --- */
.dashboard.dark .ecoles-section input,
.dashboard.dark .ecoles-section select,
.dashboard.dark .ecoles-section textarea,
.dashboard.dark .sante-section input,
.dashboard.dark .sante-section select,
.dashboard.dark .sante-section textarea {
    background: #3f4147;
    border: 1px solid rgba(255,255,255,0.15);
    color: #fff;
}

/* --- GRID --- */
.items-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 20px;
    margin-top: 20px;
}

/* --- CARD --- */
.item-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 18px;
    border: 1px solid #dcdcdc;
    box-shadow: 0 4px 12px rgba(0,0,0,0.06);
}

.item-card h3 {
    margin: 0 0 10px;
    font-size: 1.1rem;
    color: #222;
}

.item-card p {
    margin: 10px 0 0;
    color: #444;
    white-space: pre-line; /* <-- MAGIQUE */
}


/* --- TAG --- */
.item-card .tag {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: capitalize;
    color: white;
}

/* Couleurs par type */
.item-logement .tag { background: #009688; }
.item-emploi .tag { background: #ff9800; }
.item-ecole .tag { background: #3f51b5; }
.item-sante .tag { background: #e91e63; }

/* --- DARK MODE --- */
.dashboard.dark .item-card {
    background: #3f4147;
    border: 1px solid rgba(255,255,255,0.15);
}

.dashboard.dark .item-card h3,
.dashboard.dark .item-card p {
    color: #fff;
    white-space: pre-line;
}

.add-btn {
    margin-top: 15px;
    padding: 12px 18px;
    background: #6fb8af;
    color: white;
    border: none;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: 0.2s;
}

.add-btn:hover {
    opacity: 0.9;
}

/* Dark mode */
.dashboard.dark .add-btn {
    background: #6fb8af;
    color: #fff;
}

.drawer-container {
    width: 60vw;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.dashboard.dark .drawer-container {
    background: #2f3136; /* même couleur que Discord / dark mode moderne */
}

.drawer-container h2 {
    margin-bottom: 10px;
}

.dashboard.dark .drawer-container h2 {
    color: #fff;
}

.drawer-container input,
.drawer-container select,
.drawer-container textarea {
    padding: 12px;
    border-radius: 10px;
    border: 1px solid #ccc;
    background: #fafafa;
    font-size: 1rem;
}

.dashboard.dark .drawer-container input,
.dashboard.dark .drawer-container select,
.dashboard.dark .drawer-container textarea {
    background: #3f4147;
    border: 1px solid rgba(255,255,255,0.15);
    color: #fff;
}

.drawer-container textarea {
    min-height: 100px;
}

.dashboard.dark .drawer-container label {
    color: #ddd;
}

.next-btn,
.prev-btn,
.add-btn {
    padding: 12px 18px;
    border: none;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
}

.next-btn {
    background: #6fb8af;
    color: white;
}

.prev-btn {
    background: #ddd;
    color: #333;
}

.add-btn {
    background: #4caf50;
    color: white;
}

/* Dark mode */
.dashboard.dark .drawer-container input,
.dashboard.dark .drawer-container select,
.dashboard.dark .drawer-container textarea {
    background: #3f4147;
    border: 1px solid rgba(255,255,255,0.15);
    color: white;
}

.dashboard.dark .prev-btn {
    background: #555;
    color: white;
}

.dashboard.dark .MuiPaper-root.MuiDrawer-paper input,
.dashboard.dark .MuiPaper-root.MuiDrawer-paper textarea,
.dashboard.dark .MuiPaper-root.MuiDrawer-paper select {
    background: #3f4147 !important;
    color: #fff !important;
    border: 1px solid rgba(255,255,255,0.2) !important;
}

.dashboard.dark .MuiPaper-root.MuiDrawer-paper input::placeholder,
.dashboard.dark .MuiPaper-root.MuiDrawer-paper textarea::placeholder {
    color: rgba(255,255,255,0.5) !important;
}

/* --- HEADER ACTIONS --- */
.header-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 40px;
}

/* --- BOUTONS --- */
.action-btn {
    padding: 10px 18px;
    background: #6fb8af; /* TA couleur */
    color: white;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: 0.2s ease;
    font-size: 0.95rem;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.action-btn:hover {
    background: #5aa79e; /* version légèrement plus foncée */
    transform: translateY(-2px);
}

/* --- DARK MODE --- */
.dashboard.dark .action-btn {
    background: #6fb8af; /* même couleur, mais sur fond sombre ça rend super bien */
    color: #0a1929; /* texte foncé pour contraste */
}

.dashboard.dark .action-btn:hover {
    background: #5aa79e;
}

/* --- HEADER BLOCK --- */
.header-block {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 40px;
    gap: 20px;
}

/* Colonne gauche */
.header-left h1 {
    margin: 0 0 10px 0;
    font-size: 2rem;
}

.header-left p {
    opacity: 0.8;
    margin: 0;
    max-width: 900px;
}

/* Colonne droite : boutons */
.header-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: flex-end;
}

/* Boutons */
.action-btn {
    padding: 10px 18px;
    background: #6fb8af;
    color: white;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: 0.2s ease;
    font-size: 0.95rem;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.action-btn:hover {
    background: #5aa79e;
    transform: translateY(-2px);
}

/* --- DARK MODE --- */
.dashboard.dark .action-btn {
    background: #6fb8af;
    color: #0a1929;
}

.dashboard.dark .action-btn:hover {
    background: #5aa79e;
}

/* Responsive */
@media (max-width: 900px) {
    .header-block {
        flex-direction: column;
        align-items: flex-start;
    }

    .header-actions {
        justify-content: flex-start;
    }
}









/* --- DARKMODE --- */

@media (max-width: 900px) {
    .layout-two-cols {
        grid-template-columns: 1fr;
    }
}

/* --- DARK MODE (hérité du dashboard) --- */


.dashboard.dark .checklist li {
    border-color: var(--border-dark);
}

.dashboard.dark .resource-list a {
    color: #8fd1c8;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Quebec.css"],"names":[],"mappings":"AAAA,UAAU;AACV,yBAAyB;AACzB,+BAA+B;AAC/B,4CAA4C;AAC5C,IAAI;;AAEJ,mBAAmB;AACnB;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB,wBAAwB;AACxB;IACI,mBAAmB,eAAe,eAAe;IACjD,yBAAyB,SAAS,oBAAoB;IACtD,mBAAmB;IACnB,aAAa;IACb,mBAAmB,eAAe,2BAA2B;IAC7D,uCAAuC,EAAE,gBAAgB;AAC7D;;AAEA,WAAW;AACX;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA,0CAA0C;AAC1C;IACI,mBAAmB,EAAE,2BAA2B;IAChD,wCAAwC;IACxC,uCAAuC;AAC3C;;AAEA,0BAA0B;AAC1B;IACI,cAAc;AAClB;;AAEA,WAAW;AACX;;;IAGI,cAAc;AAClB;;;;AAIA,0BAA0B;AAC1B;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,wDAAwD;AAC5D;;AAEA,wBAAwB;AACxB;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,cAAc;IACd,uCAAuC;AAC3C;;;AAGA,sBAAsB;AACtB;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB,EAAE,aAAa;AACxC;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,4CAA4C;AAChD;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA,8BAA8B;;AAE9B,qBAAqB;AACrB;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,QAAQ;IACR,4BAA4B;IAC5B,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;IACnB,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;;;AAIA,sBAAsB;AACtB;IACI,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;AAClC;;AAEA,gCAAgC;;AAEhC,gCAAgC;AAChC;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;IAChB,SAAS;AACb;;AAEA,uBAAuB;AACvB;IACI,wCAAwC;AAC5C;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA,aAAa;AACb;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA,YAAY;AACZ;IACI,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA,WAAW;AACX;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA,cAAc;AACd;;IAEI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA,cAAc;AACd;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,YAAY;AAChB;;AAEA,2BAA2B;AAC3B;IACI,mBAAmB,EAAE,SAAS;AAClC;;AAEA;IACI,mBAAmB,EAAE,mBAAmB;AAC5C;;AAEA;IACI,mBAAmB,EAAE,WAAW;AACpC;;AAEA;IACI,mBAAmB,EAAE,SAAS;AAClC;;AAEA;IACI,mBAAmB,EAAE,SAAS;AAClC;;AAEA;IACI,mBAAmB,EAAE,WAAW;AACpC;;AAEA,6DAA6D;AAC7D;IACI,WAAW;AACf;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;AACf;;;AAGA,mBAAmB;AACnB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;;IAGI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;AACf;;AAEA,cAAc;AACd;;;IAGI,mBAAmB;IACnB,uCAAuC;IACvC,WAAW;AACf;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,cAAc;AACd;;IAEI,mBAAmB;IACnB,wCAAwC;IACxC,WAAW;AACf;;AAEA,gCAAgC;AAChC;;IAEI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;;;;;IAMI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA,sBAAsB;AACtB;;;;;;IAMI,mBAAmB;IACnB,wCAAwC;IACxC,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,qBAAqB,EAAE,gBAAgB;AAC3C;;;AAGA,gBAAgB;AAChB;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,YAAY;AAChB;;AAEA,sBAAsB;AACtB,sBAAsB,mBAAmB,EAAE;AAC3C,oBAAoB,mBAAmB,EAAE;AACzC,mBAAmB,mBAAmB,EAAE;AACxC,mBAAmB,mBAAmB,EAAE;;AAExC,sBAAsB;AACtB;IACI,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;;IAEI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB,EAAE,iDAAiD;AAC1E;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;;IAGI,mBAAmB;IACnB,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;;;IAGI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,cAAc;AACd;;;IAGI,mBAAmB;IACnB,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;;IAGI,8BAA8B;IAC9B,sBAAsB;IACtB,kDAAkD;AACtD;;AAEA;;IAEI,uCAAuC;AAC3C;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,mBAAmB,EAAE,eAAe;IACpC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,mBAAmB,EAAE,mCAAmC;IACxD,2BAA2B;AAC/B;;AAEA,sBAAsB;AACtB;IACI,mBAAmB,EAAE,0DAA0D;IAC/E,cAAc,EAAE,+BAA+B;AACnD;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,yBAAyB;AAC7B;;AAEA,YAAY;AACZ;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,sBAAsB;AACtB;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;;;;;;;;;AAUA,qBAAqB;;AAErB;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,4CAA4C;;;AAG5C;IACI,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB","sourcesContent":["/*:root {*/\r\n/*    --card-dark: #111;*/\r\n/*    --background-dark: #000;*/\r\n/*    --border-dark: rgba(255,255,255,0.1);*/\r\n/*}*/\r\n\r\n/* --- TITRES --- */\r\n.content h1 {\r\n    font-size: 2rem;\r\n    margin-bottom: 10px;\r\n    color: var(--text);\r\n}\r\n\r\n.content h2 {\r\n    font-size: 1.4rem;\r\n    margin-bottom: 15px;\r\n    color: var(--text);\r\n}\r\n\r\n/* --- CARD BLOCK --- */\r\n/* --- BLOC GLOBAL --- */\r\n.card-block {\r\n    background: #ffffff;              /* fond clair */\r\n    border: 1px solid #dcdcdc;        /* bordure visible */\r\n    border-radius: 12px;\r\n    padding: 25px;\r\n    margin-bottom: 30px;              /* espace entre les blocs */\r\n    box-shadow: 0 4px 12px rgba(0,0,0,0.06); /* ombre douce */\r\n}\r\n\r\n/* TITRES */\r\n.card-block h2 {\r\n    margin-top: 0;\r\n    margin-bottom: 15px;\r\n    font-size: 1.4rem;\r\n    color: #222;\r\n}\r\n\r\n/* --- DARK MODE : blocs plus clairs --- */\r\n.dashboard.dark .card-block {\r\n    background: #1a2228; /* plus clair que #2f3136 */\r\n    border: 1px solid rgba(255,255,255,0.18);\r\n    box-shadow: 0 4px 12px rgba(0,0,0,0.35);\r\n}\r\n\r\n/* Titres dans les blocs */\r\n.dashboard.dark .card-block h2 {\r\n    color: #ffffff;\r\n}\r\n\r\n/* Textes */\r\n.dashboard.dark .card-block p,\r\n.dashboard.dark .card-block label,\r\n.dashboard.dark .card-block li {\r\n    color: #e8e8e8;\r\n}\r\n\r\n\r\n\r\n/* --- BLOCS / CARDS --- */\r\n.card-block textarea {\r\n    width: 100%;\r\n    min-height: 150px;\r\n    padding: 15px;\r\n    border-radius: 8px;\r\n    border: 1px solid #ccc;\r\n    background: #ffffff;\r\n    color: #333;\r\n    font-size: 1rem;\r\n    line-height: 1.4;\r\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n/* Effet focus premium */\r\n.card-block textarea:focus {\r\n    border-color: #6fb8af;\r\n    box-shadow: 0 0 0 2px rgba(111,184,175,0.25);\r\n}\r\n\r\n/* Dark mode */\r\n.dashboard.dark .card-block textarea {\r\n    background: #2b2d31;\r\n    color: #f5f5f5;\r\n    border: 1px solid rgba(255,255,255,0.2);\r\n}\r\n\r\n\r\n/* --- CHECKLIST --- */\r\n.checklist {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.checklist li {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 8px 0;\r\n    border-bottom: 1px solid var(--border);\r\n    color: var(--text);\r\n}\r\n\r\n.checklist li:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.checklist input[type=\"checkbox\"] {\r\n    width: 18px;\r\n    height: 18px;\r\n    accent-color: #6fb8af; /* ton vert */\r\n}\r\n\r\n/* --- RESSOURCES --- */\r\n.resource-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.resource-list a {\r\n    color: #6fb8af;\r\n    text-decoration: none;\r\n    font-weight: 500;\r\n    transition: 0.2s;\r\n}\r\n\r\n.resource-list a:hover {\r\n    opacity: 0.7;\r\n}\r\n\r\n/* --- NOTES --- */\r\n.card-block textarea {\r\n    resize: vertical;\r\n    font-size: 1rem;\r\n    line-height: 1.4;\r\n}\r\n\r\n/* --- LAYOUT 2 COLS --- */\r\n.layout-two-cols {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 25px;\r\n    margin-top: 25px;\r\n}\r\n\r\n/* --- TIMELINE --- */\r\n.timeline {\r\n    position: relative;\r\n    margin-left: 20px;\r\n    padding-left: 20px;\r\n    border-left: 2px solid var(--border);\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 25px;\r\n}\r\n\r\n.timeline-item {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 15px;\r\n}\r\n\r\n.timeline-dot {\r\n    position: absolute;\r\n    left: -31px;\r\n    top: 4px;\r\n    width: 14px;\r\n    height: 14px;\r\n    background: #6fb8af;\r\n    border-radius: 50%;\r\n    border: 2px solid var(--card);\r\n    box-shadow: 0 0 0 3px rgba(111,184,175,0.25);\r\n}\r\n\r\n.timeline-content h3 {\r\n    margin: 0;\r\n    font-size: 1.1rem;\r\n    color: var(--text);\r\n}\r\n\r\n.timeline-content p {\r\n    margin: 3px 0 0;\r\n    opacity: 0.7;\r\n    color: var(--text);\r\n}\r\n\r\n/* --- SELECTED TIMELINE --- */\r\n\r\n/* --- TIMELINE --- */\r\n.timeline {\r\n    position: relative;\r\n    margin-left: 20px;\r\n    padding-left: 20px;\r\n    border-left: 2px solid #ccc;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 25px;\r\n}\r\n\r\n.dashboard.dark .timeline {\r\n    border-left-color: rgba(255,255,255,0.15);\r\n}\r\n\r\n.timeline-item {\r\n    position: relative;\r\n    padding-left: 10px;\r\n    cursor: pointer;\r\n    transition: 0.2s;\r\n}\r\n\r\n.timeline-item:hover {\r\n    opacity: 0.8;\r\n}\r\n\r\n.timeline-dot {\r\n    position: absolute;\r\n    left: -31px;\r\n    top: 4px;\r\n    width: 14px;\r\n    height: 14px;\r\n    border-radius: 50%;\r\n    border: 2px solid #fff;\r\n}\r\n\r\n/* --- STATUTS --- */\r\n.timeline-item.done .timeline-dot {\r\n    background: #4caf50;\r\n    box-shadow: 0 0 0 3px rgba(76,175,80,0.25);\r\n}\r\n\r\n.timeline-item.progress .timeline-dot {\r\n    background: #ff9800;\r\n    box-shadow: 0 0 0 3px rgba(255,152,0,0.25);\r\n}\r\n\r\n.timeline-item.todo .timeline-dot {\r\n    background: #9e9e9e;\r\n    box-shadow: 0 0 0 3px rgba(158,158,158,0.25);\r\n}\r\n\r\n.timeline-content h3 {\r\n    margin: 0;\r\n    font-size: 1.1rem;\r\n    color: var(--text);\r\n}\r\n\r\n.timeline-content .date {\r\n    margin: 3px 0 0;\r\n    opacity: 0.7;\r\n    color: var(--text);\r\n}\r\n\r\n.dashboard.dark .timeline-dot {\r\n    border-color: #2f3136;\r\n}\r\n\r\n/* --- MODAL --- */\r\n.modal-overlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0,0,0,0.55);\r\n    backdrop-filter: blur(3px);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 2000;\r\n}\r\n\r\n/* Light mode modal */\r\n.modal-card {\r\n    background: #ffffff;\r\n    border: 1px solid #ddd;\r\n    padding: 25px;\r\n    border-radius: 12px;\r\n    width: 400px;\r\n    max-width: 90%;\r\n    box-shadow: 0 8px 30px rgba(0,0,0,0.3);\r\n    animation: fadeIn 0.2s ease;\r\n}\r\n\r\n/* Dark mode modal */\r\n.dashboard.dark .modal-card {\r\n    background: #2f3136;\r\n    border: 1px solid rgba(255,255,255,0.12);\r\n    color: #f5f5f5;\r\n}\r\n\r\n.close-btn {\r\n    margin-top: 20px;\r\n    padding: 10px 15px;\r\n    background: #6fb8af;\r\n    border: none;\r\n    border-radius: 8px;\r\n    color: white;\r\n    cursor: pointer;\r\n    width: 100%;\r\n}\r\n\r\n.close-btn:hover {\r\n    opacity: 0.8;\r\n}\r\n\r\n@keyframes fadeIn {\r\n    from { opacity: 0; transform: translateY(10px); }\r\n    to { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n\r\n\r\n/* --- DARK MODE --- */\r\n.dashboard.dark .timeline {\r\n    border-left-color: var(--border-dark);\r\n}\r\n\r\n.dashboard.dark .timeline-dot {\r\n    border-color: var(--card-dark);\r\n}\r\n\r\n/* --- TIMELINE HORIZONTAL --- */\r\n\r\n/* --- TIMELINE HORIZONTAL --- */\r\n.timeline-horizontal {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    position: relative;\r\n    padding: 40px 10px 20px;\r\n    border-top: 2px solid #ccc;\r\n    overflow-x: auto;\r\n    gap: 40px;\r\n}\r\n\r\n/* Ligne en dark mode */\r\n.dashboard.dark .timeline-horizontal {\r\n    border-top-color: rgba(255,255,255,0.15);\r\n}\r\n\r\n/* Chaque étape */\r\n.th-item {\r\n    position: relative;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    min-width: 150px;\r\n    transition: 0.2s;\r\n}\r\n\r\n.th-item:hover {\r\n    opacity: 0.8;\r\n}\r\n\r\n/* Pastille */\r\n.th-dot {\r\n    width: 16px;\r\n    height: 16px;\r\n    border-radius: 50%;\r\n    margin: 0 auto;\r\n    margin-bottom: 10px;\r\n    border: 3px solid #fff;\r\n}\r\n\r\n/* Statuts */\r\n.th-item.done .th-dot {\r\n    background: #4caf50;\r\n    box-shadow: 0 0 0 4px rgba(76,175,80,0.25);\r\n}\r\n\r\n.th-item.progress .th-dot {\r\n    background: #ff9800;\r\n    box-shadow: 0 0 0 4px rgba(255,152,0,0.25);\r\n}\r\n\r\n.th-item.todo .th-dot {\r\n    background: #9e9e9e;\r\n    box-shadow: 0 0 0 4px rgba(158,158,158,0.25);\r\n}\r\n\r\n/* Textes */\r\n.th-title {\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    margin: 0;\r\n    color: #333;\r\n}\r\n\r\n.th-date {\r\n    font-size: 0.85rem;\r\n    opacity: 0.7;\r\n    margin: 5px 0 0;\r\n    color: #333;\r\n}\r\n\r\n/* Dark mode */\r\n.dashboard.dark .th-title,\r\n.dashboard.dark .th-date {\r\n    color: #f5f5f5;\r\n}\r\n\r\n.dashboard.dark .th-dot {\r\n    border-color: #2f3136;\r\n}\r\n\r\n/* --- PROGRESSION --- */\r\n.progress-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.progress-bar {\r\n    width: 100%;\r\n    height: 14px;\r\n    background: #e0e0e0;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    position: relative;\r\n}\r\n\r\n.progress-fill {\r\n    height: 100%;\r\n    background: #6fb8af;\r\n    border-radius: 8px;\r\n    transition: width 0.4s ease;\r\n}\r\n\r\n.progress-text {\r\n    font-size: 0.95rem;\r\n    font-weight: 600;\r\n    color: #333;\r\n}\r\n\r\n/* Dark mode */\r\n.dashboard.dark .progress-bar {\r\n    background: #3a3b3d;\r\n}\r\n\r\n.dashboard.dark .progress-text {\r\n    color: #f5f5f5;\r\n}\r\n\r\n/* --- TAGS --- */\r\n.tag {\r\n    display: inline-block;\r\n    padding: 4px 10px;\r\n    border-radius: 20px;\r\n    font-size: 0.75rem;\r\n    font-weight: 600;\r\n    text-transform: capitalize;\r\n    margin-top: 8px;\r\n    color: white;\r\n}\r\n\r\n/* Couleurs par catégorie */\r\n.tag-administratif {\r\n    background: #3f51b5; /* bleu */\r\n}\r\n\r\n.tag-logement {\r\n    background: #009688; /* vert turquoise */\r\n}\r\n\r\n.tag-emploi {\r\n    background: #ff9800; /* orange */\r\n}\r\n\r\n.tag-banque {\r\n    background: #4caf50; /* vert */\r\n}\r\n\r\n.tag-santé {\r\n    background: #e91e63; /* rose */\r\n}\r\n\r\n.tag-éducation {\r\n    background: #9c27b0; /* violet */\r\n}\r\n\r\n/* Dark mode : couleurs identiques, mais texte plus lisible */\r\n.dashboard.dark .tag {\r\n    color: #fff;\r\n}\r\n\r\n/* --- BUDGET GRID --- */\r\n.budget-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 25px;\r\n    margin-top: 20px;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n    .budget-grid {\r\n        grid-template-columns: 1fr;\r\n    }\r\n}\r\n\r\n.budget-item {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n}\r\n\r\n.budget-item label {\r\n    font-size: 0.95rem;\r\n    font-weight: 600;\r\n    color: #222;\r\n}\r\n\r\n.budget-item input {\r\n    padding: 12px 14px;\r\n    border-radius: 10px;\r\n    border: 1px solid #d0d0d0;\r\n    background: #fafafa;\r\n    color: #222;\r\n    font-size: 1rem;\r\n    transition: 0.2s;\r\n}\r\n\r\n.budget-item input:focus {\r\n    border-color: #6fb8af;\r\n    background: #fff;\r\n    box-shadow: 0 0 0 2px rgba(111,184,175,0.25);\r\n}\r\n\r\n/* --- TOTAL --- */\r\n.budget-total {\r\n    margin-top: 30px;\r\n    padding: 18px;\r\n    background: #f0f0f0;\r\n    border-radius: 10px;\r\n    border: 1px solid #d0d0d0;\r\n}\r\n\r\n.budget-total h3 {\r\n    margin: 0;\r\n    font-size: 1.3rem;\r\n    color: #222;\r\n}\r\n\r\n.budget-total span {\r\n    color: #6fb8af;\r\n    font-weight: 700;\r\n}\r\n\r\n/* --- DARK MODE --- */\r\n.dashboard.dark .budget-item label {\r\n    color: #f5f5f5;\r\n}\r\n\r\n.dashboard.dark .budget-item input {\r\n    background: #3f4147;\r\n    border: 1px solid rgba(255,255,255,0.15);\r\n    color: #fff;\r\n}\r\n\r\n.dashboard.dark .budget-item input:focus {\r\n    border-color: #6fb8af;\r\n    background: #4a4c53;\r\n    box-shadow: 0 0 0 2px rgba(111,184,175,0.25);\r\n}\r\n\r\n.dashboard.dark .budget-total {\r\n    background: #3f4147;\r\n    border: 1px solid rgba(255,255,255,0.15);\r\n}\r\n\r\n.dashboard.dark .budget-total h3 {\r\n    color: #fff;\r\n}\r\n\r\n\r\n/* --- ONGLET --- */\r\n.tabs {\r\n    display: flex;\r\n    gap: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.tabs button {\r\n    padding: 10px 18px;\r\n    border-radius: 8px;\r\n    border: 1px solid #ccc;\r\n    background: #f5f5f5;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n    transition: 0.2s;\r\n}\r\n\r\n.tabs button.active {\r\n    background: #6fb8af;\r\n    color: white;\r\n    border-color: #6fb8af;\r\n}\r\n\r\n.tabs button:hover {\r\n    opacity: 0.85;\r\n}\r\n\r\n/* Dark mode */\r\n.dashboard.dark .tabs button {\r\n    background: #3a3c42;\r\n    border: 1px solid rgba(255,255,255,0.15);\r\n    color: #fff;\r\n}\r\n\r\n.dashboard.dark .tabs button.active {\r\n    background: #6fb8af;\r\n    border-color: #6fb8af;\r\n    color: #fff;\r\n}\r\n\r\n/* --- LOGEMENT --- */\r\n.logement-section {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n}\r\n\r\n.logement-section input,\r\n.logement-section select,\r\n.logement-section textarea {\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    border: 1px solid #ccc;\r\n    background: #fff;\r\n    color: #333;\r\n}\r\n\r\n/* Dark mode */\r\n.dashboard.dark .logement-section input,\r\n.dashboard.dark .logement-section select,\r\n.dashboard.dark .logement-section textarea {\r\n    background: #2b2d31;\r\n    border: 1px solid rgba(255,255,255,0.2);\r\n    color: #fff;\r\n}\r\n\r\n/* --- EMPLOI SECTION --- */\r\n.emploi-section {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n}\r\n\r\n.emploi-section input,\r\n.emploi-section textarea {\r\n    padding: 12px;\r\n    border-radius: 10px;\r\n    border: 1px solid #ccc;\r\n    background: #fafafa;\r\n    color: #222;\r\n    font-size: 1rem;\r\n}\r\n\r\n.emploi-section textarea {\r\n    min-height: 100px;\r\n}\r\n\r\n/* Dark mode */\r\n.dashboard.dark .emploi-section input,\r\n.dashboard.dark .emploi-section textarea {\r\n    background: #3f4147;\r\n    border: 1px solid rgba(255,255,255,0.15);\r\n    color: #fff;\r\n}\r\n\r\n/* --- SECTIONS GENERIQUES --- */\r\n.ecoles-section,\r\n.sante-section {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n}\r\n\r\n.ecoles-section input,\r\n.ecoles-section select,\r\n.ecoles-section textarea,\r\n.sante-section input,\r\n.sante-section select,\r\n.sante-section textarea {\r\n    padding: 12px;\r\n    border-radius: 10px;\r\n    border: 1px solid #ccc;\r\n    background: #fafafa;\r\n    color: #222;\r\n    font-size: 1rem;\r\n}\r\n\r\n.ecoles-section textarea,\r\n.sante-section textarea {\r\n    min-height: 100px;\r\n}\r\n\r\n/* --- DARK MODE --- */\r\n.dashboard.dark .ecoles-section input,\r\n.dashboard.dark .ecoles-section select,\r\n.dashboard.dark .ecoles-section textarea,\r\n.dashboard.dark .sante-section input,\r\n.dashboard.dark .sante-section select,\r\n.dashboard.dark .sante-section textarea {\r\n    background: #3f4147;\r\n    border: 1px solid rgba(255,255,255,0.15);\r\n    color: #fff;\r\n}\r\n\r\n/* --- GRID --- */\r\n.items-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\r\n    gap: 20px;\r\n    margin-top: 20px;\r\n}\r\n\r\n/* --- CARD --- */\r\n.item-card {\r\n    background: #ffffff;\r\n    border-radius: 12px;\r\n    padding: 18px;\r\n    border: 1px solid #dcdcdc;\r\n    box-shadow: 0 4px 12px rgba(0,0,0,0.06);\r\n}\r\n\r\n.item-card h3 {\r\n    margin: 0 0 10px;\r\n    font-size: 1.1rem;\r\n    color: #222;\r\n}\r\n\r\n.item-card p {\r\n    margin: 10px 0 0;\r\n    color: #444;\r\n    white-space: pre-line; /* <-- MAGIQUE */\r\n}\r\n\r\n\r\n/* --- TAG --- */\r\n.item-card .tag {\r\n    display: inline-block;\r\n    padding: 4px 10px;\r\n    border-radius: 20px;\r\n    font-size: 0.75rem;\r\n    font-weight: 600;\r\n    text-transform: capitalize;\r\n    color: white;\r\n}\r\n\r\n/* Couleurs par type */\r\n.item-logement .tag { background: #009688; }\r\n.item-emploi .tag { background: #ff9800; }\r\n.item-ecole .tag { background: #3f51b5; }\r\n.item-sante .tag { background: #e91e63; }\r\n\r\n/* --- DARK MODE --- */\r\n.dashboard.dark .item-card {\r\n    background: #3f4147;\r\n    border: 1px solid rgba(255,255,255,0.15);\r\n}\r\n\r\n.dashboard.dark .item-card h3,\r\n.dashboard.dark .item-card p {\r\n    color: #fff;\r\n    white-space: pre-line;\r\n}\r\n\r\n.add-btn {\r\n    margin-top: 15px;\r\n    padding: 12px 18px;\r\n    background: #6fb8af;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 10px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: 0.2s;\r\n}\r\n\r\n.add-btn:hover {\r\n    opacity: 0.9;\r\n}\r\n\r\n/* Dark mode */\r\n.dashboard.dark .add-btn {\r\n    background: #6fb8af;\r\n    color: #fff;\r\n}\r\n\r\n.drawer-container {\r\n    width: 60vw;\r\n    padding: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n}\r\n\r\n.dashboard.dark .drawer-container {\r\n    background: #2f3136; /* même couleur que Discord / dark mode moderne */\r\n}\r\n\r\n.drawer-container h2 {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.dashboard.dark .drawer-container h2 {\r\n    color: #fff;\r\n}\r\n\r\n.drawer-container input,\r\n.drawer-container select,\r\n.drawer-container textarea {\r\n    padding: 12px;\r\n    border-radius: 10px;\r\n    border: 1px solid #ccc;\r\n    background: #fafafa;\r\n    font-size: 1rem;\r\n}\r\n\r\n.dashboard.dark .drawer-container input,\r\n.dashboard.dark .drawer-container select,\r\n.dashboard.dark .drawer-container textarea {\r\n    background: #3f4147;\r\n    border: 1px solid rgba(255,255,255,0.15);\r\n    color: #fff;\r\n}\r\n\r\n.drawer-container textarea {\r\n    min-height: 100px;\r\n}\r\n\r\n.dashboard.dark .drawer-container label {\r\n    color: #ddd;\r\n}\r\n\r\n.next-btn,\r\n.prev-btn,\r\n.add-btn {\r\n    padding: 12px 18px;\r\n    border: none;\r\n    border-radius: 10px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n}\r\n\r\n.next-btn {\r\n    background: #6fb8af;\r\n    color: white;\r\n}\r\n\r\n.prev-btn {\r\n    background: #ddd;\r\n    color: #333;\r\n}\r\n\r\n.add-btn {\r\n    background: #4caf50;\r\n    color: white;\r\n}\r\n\r\n/* Dark mode */\r\n.dashboard.dark .drawer-container input,\r\n.dashboard.dark .drawer-container select,\r\n.dashboard.dark .drawer-container textarea {\r\n    background: #3f4147;\r\n    border: 1px solid rgba(255,255,255,0.15);\r\n    color: white;\r\n}\r\n\r\n.dashboard.dark .prev-btn {\r\n    background: #555;\r\n    color: white;\r\n}\r\n\r\n.dashboard.dark .MuiPaper-root.MuiDrawer-paper input,\r\n.dashboard.dark .MuiPaper-root.MuiDrawer-paper textarea,\r\n.dashboard.dark .MuiPaper-root.MuiDrawer-paper select {\r\n    background: #3f4147 !important;\r\n    color: #fff !important;\r\n    border: 1px solid rgba(255,255,255,0.2) !important;\r\n}\r\n\r\n.dashboard.dark .MuiPaper-root.MuiDrawer-paper input::placeholder,\r\n.dashboard.dark .MuiPaper-root.MuiDrawer-paper textarea::placeholder {\r\n    color: rgba(255,255,255,0.5) !important;\r\n}\r\n\r\n/* --- HEADER ACTIONS --- */\r\n.header-actions {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 15px;\r\n    margin-bottom: 40px;\r\n}\r\n\r\n/* --- BOUTONS --- */\r\n.action-btn {\r\n    padding: 10px 18px;\r\n    background: #6fb8af; /* TA couleur */\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: 0.2s ease;\r\n    font-size: 0.95rem;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.action-btn:hover {\r\n    background: #5aa79e; /* version légèrement plus foncée */\r\n    transform: translateY(-2px);\r\n}\r\n\r\n/* --- DARK MODE --- */\r\n.dashboard.dark .action-btn {\r\n    background: #6fb8af; /* même couleur, mais sur fond sombre ça rend super bien */\r\n    color: #0a1929; /* texte foncé pour contraste */\r\n}\r\n\r\n.dashboard.dark .action-btn:hover {\r\n    background: #5aa79e;\r\n}\r\n\r\n/* --- HEADER BLOCK --- */\r\n.header-block {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    margin-bottom: 40px;\r\n    gap: 20px;\r\n}\r\n\r\n/* Colonne gauche */\r\n.header-left h1 {\r\n    margin: 0 0 10px 0;\r\n    font-size: 2rem;\r\n}\r\n\r\n.header-left p {\r\n    opacity: 0.8;\r\n    margin: 0;\r\n    max-width: 900px;\r\n}\r\n\r\n/* Colonne droite : boutons */\r\n.header-actions {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 12px;\r\n    justify-content: flex-end;\r\n}\r\n\r\n/* Boutons */\r\n.action-btn {\r\n    padding: 10px 18px;\r\n    background: #6fb8af;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: 0.2s ease;\r\n    font-size: 0.95rem;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.action-btn:hover {\r\n    background: #5aa79e;\r\n    transform: translateY(-2px);\r\n}\r\n\r\n/* --- DARK MODE --- */\r\n.dashboard.dark .action-btn {\r\n    background: #6fb8af;\r\n    color: #0a1929;\r\n}\r\n\r\n.dashboard.dark .action-btn:hover {\r\n    background: #5aa79e;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 900px) {\r\n    .header-block {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n    }\r\n\r\n    .header-actions {\r\n        justify-content: flex-start;\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* --- DARKMODE --- */\r\n\r\n@media (max-width: 900px) {\r\n    .layout-two-cols {\r\n        grid-template-columns: 1fr;\r\n    }\r\n}\r\n\r\n/* --- DARK MODE (hérité du dashboard) --- */\r\n\r\n\r\n.dashboard.dark .checklist li {\r\n    border-color: var(--border-dark);\r\n}\r\n\r\n.dashboard.dark .resource-list a {\r\n    color: #8fd1c8;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
